import { StatusCodes } from "http-status-codes";

/** `errorCode` sent by the core api when a request is rejected due to the maintenance mode */
export const MAINTENANCE_MODE_ERROR_CODE = "MaintenanceMode";

export const isMaintenanceModeError = (error: unknown): boolean => {
  const response = (error as { response?: { status?: number; data?: { errorCode?: string } } } | undefined)?.response;
  return (
    response?.status === StatusCodes.SERVICE_UNAVAILABLE && response.data?.errorCode === MAINTENANCE_MODE_ERROR_CODE
  );
};
